import type { CSSProperties, HTMLAttributes } from 'react';

// Logo "A" circolare con dot ambra e 5 stati animati (CSS puro, no SVG).
// Vincolo design: implementazione CSS-only, animation handled by audiq-mark.css.
// Stati: idle / listening / thinking / speaking / done.

export type AudiqMarkState = 'idle' | 'listening' | 'thinking' | 'speaking' | 'done';

export interface AudiqMarkProps extends HTMLAttributes<HTMLDivElement> {
  /** Diametro del cerchio in px */
  size?: number;
  state?: AudiqMarkState;
  /** Caption testuale sotto il mark (DM Mono mute) */
  caption?: string;
}

export function AudiqMark({
  size = 96,
  state = 'idle',
  caption,
  className,
  style,
  ...rest
}: AudiqMarkProps) {
  const composedStyle: CSSProperties = {
    ...style,
  };

  return (
    <div
      className={`audiq-mark-card s-${state} ${className ?? ''}`}
      style={composedStyle}
      data-state={state}
      {...rest}
    >
      <div className="audiq-mark-stage">
        <div className="audiq-mark" style={{ '--audiq-mark-size': `${size}px` } as CSSProperties}>
          {state === 'listening' && (
            <>
              <span className="audiq-mark-ring r1" />
              <span className="audiq-mark-ring r2" />
              <span className="audiq-mark-ring r3" />
              <div className="audiq-mark-eq" aria-hidden="true">
                <i />
                <i />
                <i />
                <i />
                <i />
              </div>
            </>
          )}
          {state === 'thinking' && <span className="audiq-mark-ring orbit" />}
          {state === 'speaking' && <span className="audiq-mark-ring speak" />}
          {state === 'done' && <span className="audiq-mark-ring done" />}
          <span className="audiq-mark-letter">A</span>
          <span className="audiq-mark-dot" />
        </div>
      </div>
      {caption && <div className="audiq-mark-caption">{caption}</div>}
    </div>
  );
}
